import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { IDENTITY_STREAM_ID } from '../../constants';
import { getViewOptions } from './options';
export function isInitialized(state) {
    return streamSelectors.isInitialized(state, IDENTITY_STREAM_ID);
}
export function isLoading(state) {
    return streamSelectors.isFetching(state, IDENTITY_STREAM_ID);
}
export function getList(state) {
    return streamSelectors.getItems(state, IDENTITY_STREAM_ID);
}
export function getActiveIdentity(state) {
    var _getViewOptions;
    const folder = (_getViewOptions = getViewOptions(state)) === null || _getViewOptions === void 0 ? void 0 : _getViewOptions.activeFolder;
    const list = getList(state);
    return folder !== undefined ? getList(state).find((item)=>(item === null || item === void 0 ? void 0 : item.inboxFolderId) === folder || (item === null || item === void 0 ? void 0 : item.removedFolderId) === folder || (item === null || item === void 0 ? void 0 : item.savedFolderId) === folder) : list[0];
}
export function isGroupIdentitySelected(state) {
    const active = getActiveIdentity(state);
    const list = getList(state);
    // We assume that first in list is user's own folder
    return active && list.length > 0 && active.gruser.userId !== list[0].gruser.userId;
}
export function getActiveFolderType(state) {
    var _getViewOptions;
    const folder = (_getViewOptions = getViewOptions(state)) === null || _getViewOptions === void 0 ? void 0 : _getViewOptions.activeFolder;
    const identity = getActiveIdentity(state);
    if (folder && (identity === null || identity === void 0 ? void 0 : identity.savedFolderId) === folder) {
        return 'saved';
    }
    if (folder && (identity === null || identity === void 0 ? void 0 : identity.removedFolderId) === folder) {
        return 'archived';
    }
    return 'inbox';
}

//# sourceMappingURL=identity.js.map